export const ADD_PAYMENT = {
  BANK_DETAILS: "أدخل بيانات الحساب البنكي",
  MONEY_DEPOSIT: "سوف يتم إيداع الأموال في هذا الحساب",
  MEANS_OF_RECEIVING: "وﺳﺎﺋﻞ الإستلام",
  EARNINGS: "يتم تحويل الأرباح تلقائيًا للحساب البنكي المربوط بحسابك.",
};

export const FIELDS = {
  BENEFICIARY_NAME: "اسم المستفيد",
  BANK: "البنك",
  BANK_NAME: "اسم البنك",
  IBAN: "IBAN",
};

export const BUTTON = {
  ADD_SAVE: "إضافة وحفظ",
  MODIFY: "تعديل",
};
